import { useEffect, useState } from 'react'
import { Dialog, Button, Box } from '@chakra-ui/react'

export const SafeSearchGuideModal = ({ isOpen, onClose, tagRef }) => {
  const [tagPosition, setTagPosition] = useState({ top: 0 })

  useEffect(() => {
    if (tagRef.current) {
      const rect = tagRef.current.getBoundingClientRect()
      setTagPosition({ top: rect.top - 149 })
    }
  }, [isOpen, tagRef])

  return (
    <Dialog.Root open={isOpen} onOpenChange={(details) => !details.open && onClose()} placement="center">
      <Dialog.Backdrop zIndex={1000} />
      <Dialog.Positioner>
        <Dialog.Content w="100%" maxW="372px" h="130px" borderRadius="12px" p={4} position="absolute" zIndex={1000} top={`${tagPosition.top}px`}>
          <Dialog.Body fontSize="sm" fontWeight="bold" p={0} mb={4}>
            TL、BLジャンルの作品を表示したい場合はセーフサーチをOFFにしてください。
          </Dialog.Body>
          <Dialog.Footer justifyContent="center" p={0}>
            <Button w="100px" variant="outline" onClick={onClose}>
              OK
            </Button>
          </Dialog.Footer>
          <Box position="absolute" bottom="-10px" left="68%" width="20px" height="10px" bg="white" clipPath="polygon(0% 0%, 100% 0%, 50% 100%)" />
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  )
}
